import React, { Component } from "react";
import {
  View,
  StyleSheet,
  TouchableHighlight,
  ScrollView,
} from "react-native";
import Text from "../../components_v2/TextFont";
// import { TouchableHighlight } from "react-native-gesture-handler";
import ArTheme from "../../argon-ui/Theme";
import PropTypes from "prop-types";

import { translate } from "../../locales/translate";
import { IconButton } from "../../components_v2/Buttons";
import { getIconPicture } from "./Icons";
import { englishToPersianNumber } from "../../util";
import { FONT_FAMILIES } from "../../../assets/consts/faCharCodes";
/**@argument {Component <Props,state>} */
class OrderListItem extends Component {
  static propTypes = {
    onPress: PropTypes.func,
    orderData: PropTypes.object,
    toast: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnPress = () => {
    if (this.props.onPress) {
      this.props.onPress();
    }
  };

  render() {
    let statusText = translate("api.orderStatus") + ": ";

    statusText += translate(
      `api.orderStatuses.${
        this.props.orderData.numRequestStatus ||
        this.props.orderData.numOrderStatus
      }`
    );
    return (
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          borderBottomWidth: 1,
          borderColor: ArTheme.COLORS.MUTED,
          padding: 3,
          height: 58,
        }}
      >
        <IconButton
          onPress={this.handleOnPress}
          style={{
            width: 50,
            height: 50,
            borderRadius: 25,
            borderWidth: 1,
            borderColor: ArTheme.COLORS.MUTED,
            alignItems: "center",
            justifyContent: "center",
          }}
          icon={{
            code: getIconPicture(
              "facilityIcons",
              this.props.orderData.numPublicServiceType
            ),
            style: {
              fontFamily: FONT_FAMILIES.PRO_REGULAR,
              fontSize:
                this.props.orderData.numPublicServiceType == "Parking"
                  ? 37
                  : 27,
              color: "#006666",
            },
          }}
        />

        <View
          style={{
            flexGrow: 1,
            flex: 1,
            paddingStart: 7,
            paddingEnd: 5,
            justifyContent: "center",
          }}
        >
          <TouchableHighlight
            underlayColor="#ddd"
            onPress={() => {
              this.handleOnPress();
            }}
          >
            <View>
              <ScrollView horizontal contentContainerStyle={{ flexGrow: 1 }}>
                <View
                  style={{ flexDirection: "row", textAlignVertical: "top" }}
                >
                  <Text style={styles.mainText}>
                    {translate("api.orderId")}:
                  </Text>
                  <Text style={styles.numbers}>
                    {englishToPersianNumber(
                      this.props.orderData.numRequestID
                    ) ||
                      englishToPersianNumber(this.props.orderData.numOrderID)}
                  </Text>
                  <Text style={styles.mainText}> - </Text>
                  {/* <Text style={styles.mainText}>{translate("api.orderUnit")}: </Text> */}
                  <Text style={styles.numbers}>
                    {this.props.orderData.strUnitName}
                  </Text>
                  <Text style={styles.mainText}> - </Text>
                  <Text style={styles.mainText}>
                    {translate("api.orderDate")}:{" "}
                  </Text>
                  <Text style={styles.numbers}>
                    {englishToPersianNumber(
                      this.props.orderData.dtPDate ||
                        this.props.orderData.dtRegPDate
                    )}{" "}
                    {englishToPersianNumber(
                      this.props.orderData.dtPTime ||
                        this.props.orderData.dtRegTime
                    )}
                  </Text>
                </View>
              </ScrollView>
              <View style={{ flexDirection: "row", textAlignVertical: "top" }}>
                <Text ellipsizeMode="tail" numberOfLines={1}>
                  {this.props.strService != "Parking" && (
                    <Text style={styles.descText}>
                      {translate("api.orderedItems")}{" "}
                    </Text>
                  )}
                  {this.props.strService != "Parking" && (
                    <Text style={styles.descText}>
                      {this.props.orderData.strServicesName ||
                        this.props.strService}{" "}
                    </Text>
                  )}
                  <Text style={styles.descText}>
                    {translate("api.orderDesc")}:{" "}
                  </Text>
                  <Text style={styles.descText}>
                    {this.props.orderData.strRequestDesc ||
                      this.props.orderData.strOrderDesc}
                  </Text>
                </Text>
              </View>
            </View>
          </TouchableHighlight>
        </View>
        <IconButton
          style={{
            width: 47,
            height: 52,
            borderColor: ArTheme.COLORS.BORDER_COLOR,
            borderStartWidth: 1,
            alignItem: "center",
            justifyContent: "center",
          }}
          icon={{
            code: getIconPicture(
              "statusOrder",
              this.props.orderData.numRequestStatus ||
                this.props.orderData.numOrderStatus
            ),
            style: {
              fontFamily: FONT_FAMILIES.PRO_REGULAR,
              fontSize: 30,
              color: "#999",
            },
          }}
          onPress={() => {
            this.props.toast(statusText);
          }}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  numbers: {
    fontFamily: "IRANSansWebFaNum",
    fontSize: 15,
  },
  mainText: {
    fontSize: 18,
  },
  descText: {
    fontSize: 14,
    color: "gray",
  },
});

export default OrderListItem;
